export const NAME = 'sellerRequest-partner';

export const dialogs = {
	NO_PS_NUMBER: 'NO_PS_NUMBER',
	DOCUMENT_NOT_FOUND_DIALOG: 'DOCUMENT_NOT_FOUND_DIALOG',
};

// PS + clientInfo
export const partnerFields = [
	'policyNumber',
	'proposalNumber',
	'policyHolderFirstName',
	'policyHolderSurname',
	'policyHolderBusinessName',
	'policyStatus',
	'backOfficeSegment',
	'title',
	'surname',
	'firstName',
	'birthDate',
	'personIn',
	'businessName',
	'businessIn',
	'street',
	'streetNo',
	'municipality',
	'zipCode',
	'phoneNumber',
	'email',
];

export const taskTypeSellerRequest = '12';
export const taskTypeMobileScan = '60';
export const taskTypeBackoffice = '62';
export const taskTypeContactClient = '72';

export const defaultTaskSubtypeBackoffice = '179'; // BO NEI subType
